import React from "react";
import { Grid, Box, Typography, Divider } from "@mui/material";
import { Link } from "react-router-dom";
import CustomButton from "../CustomButton";

const CardComponent = ({
  tab,
  popupMainPhoneNumberList,
  topCustomersList,
  phoneNumberCount,
}) => {
  return (
    <>
      <Typography variant="h1" sx={{ margin: "5px 0" }}>
        {tab?.detail?.name}
      </Typography>
      <Divider />
      <Grid container>
        <Grid item lg={6} md={4} xs={12} sx={{ paddingTop: "10px" }}>
          <Box display="flex" flexDirection="row">
            <Typography variant="h3">Staff Total:</Typography>
            <Typography variant="h6" sx={{ paddingLeft: "5px" }}>
              {tab?.detail?.staffTotal}
            </Typography>
          </Box>
        </Grid>
        <Grid item lg={6} md={4} xs={12} sx={{ paddingTop: "10px" }}>
          <Box display="flex" flexDirection="row">
            <Typography variant="h3">Leader of Facility:</Typography>
            <Typography variant="h6" sx={{ paddingLeft: "5px" }}>
              {tab?.detail?.leaderOfFacility}
            </Typography>
          </Box>
        </Grid>
      </Grid>
      <Typography variant="h2" sx={{ paddingTop: "10px" }}>
        Phone Numbers
      </Typography>
      <Grid container>
        <Grid item lg={phoneNumberCount} xs={12} style={{ paddingTop: "7px" }}>
          <Typography variant="h4">Mainline:</Typography>
          {popupMainPhoneNumberList &&
            popupMainPhoneNumberList.map((mainPhoneNumber) => (
              <Typography
                key={mainPhoneNumber}
                style={{ margin: "2px" }}
                variant="body2"
              >
                {mainPhoneNumber}
              </Typography>
            ))}
        </Grid>
        {tab?.detail?.security && (
          <Grid
            item
            lg={phoneNumberCount}
            xs={12}
            style={{ paddingTop: "7px", marginTop: "0px" }}
          >
            <Typography variant="h4">Security:</Typography>
            <Typography variant="body2" style={{ margin: "2px" }}>
              {tab?.detail?.security}
            </Typography>
          </Grid>
        )}
        {tab?.detail?.controlRoom && (
          <Grid
            item
            lg={phoneNumberCount}
            xs={12}
            style={{ paddingTop: "7px" }}
          >
            <Typography variant="h4">Control Room:</Typography>
            <Typography variant="body2" style={{ margin: "2px" }}>
              {tab?.detail?.controlRoom}
            </Typography>
          </Grid>
        )}
        {tab?.detail?.emergencyPhone && (
          <Grid
            item
            lg={phoneNumberCount}
            xs={12}
            style={{ paddingTop: "7px" }}
          >
            <Typography variant="h4">Emergency Phone:</Typography>
            <Typography variant="body2" style={{ margin: "2px" }}>
              {tab?.detail?.emergencyPhone}
            </Typography>
          </Grid>
        )}
      </Grid>
      <Grid container>
        <Grid item lg={6} xs={12}>
          <Typography variant="h2" sx={{ paddingTop: "7px" }}>
            Top Customers
          </Typography>
          {topCustomersList &&
            topCustomersList.map((customer, index) => (
              <Typography
                variant="body1"
                key={"customer" + index}
                style={{ margin: "2px" }}
              >
                {index + 1}
                {". "}
                {customer}
              </Typography>
            ))}
        </Grid>
        <Grid item lg={6} xs={12}>
          <Typography variant="h2" sx={{ paddingTop: "7px" }}>
            Products produced in addition to residue sales
          </Typography>
          <Typography variant="body1" style={{ margin: "2px" }}>
            {tab?.detail?.productsProduced}
          </Typography>
        </Grid>
      </Grid>
      <Grid container>
        <Grid
          item
          lg={6}
          xs={12}
          sx={{ paddingTop: "10px", paddingRight: "10px" }}
        >
          <CustomButton
            fullWidth
            variant="outlined"
            size="small"
            component={Link}
            to={tab?.detail?.googleMap}
            target="blank"
            sx={{ border: "1px solid #4D4D4D" }}
          >
            Directions
          </CustomButton>
        </Grid>
        <Grid
          item
          lg={6}
          xs={12}
          sx={{ paddingTop: "10px", paddingRight: "10px" }}
        >
          <CustomButton
            hidden={!tab?.detail?.facilityInformation}
            fullWidth
            variant="outlined"
            size="small"
            component={Link}
            to={tab?.detail?.facilityInformation}
            target="blank"
            sx={{ border: "1px solid #4D4D4D" }}
          >
            Facility Information
          </CustomButton>
        </Grid>
      </Grid>
    </>
  );
};

export default CardComponent;